
import { DataType } from "@dndModels/Types";
import { ModelBase } from "@models/UpsertableBase";

/**
 * This is for holding groups from everything like 
 * the Harpers, the Red Wizards of Thay, to military groups,
 * to Acquisitions Incorporated.  
 * 
 * I particularly designed it with Acq Inc in mind.
 */
export class Organization extends ModelBase {
  data_type: DataType = "organization";

  constructor(obj?: any) {
    super(obj);
    if (obj) {
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  // }

  toDBObj(): any {
    const from_super = super.toDBObj();
    return {
      ...from_super,
    };
  }

  copy(copyMe: Organization, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
  }

  clone(drop_ids = false): Organization {
    const new_obj = new Organization();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}